import { getPackCoefficient, equivalenciaCompraValida } from "utils/provisionQuantity";

// La referencia actual no modifica el presupuesto histórico del expediente.
export const referenciaCotizacion = (detalle) => {
  if (!detalle?.materiaPrima || !detalle.requierePack) return Number(detalle?.precioEstimado) > 0 ? Number(detalle.precioEstimado) : null;
  if (detalle.equivalenciaRequiereConfirmacion || !equivalenciaCompraValida(detalle)) return null;
  const precio = Number(detalle.materiaPrima.precio);
  return precio > 0 ? Math.round((precio * getPackCoefficient(detalle) + Number.EPSILON) * 100) / 100 : null;
};

export const diferenciaCotizacion = (detalle, precio) => {
  const referencia = referenciaCotizacion(detalle);
  if (!(referencia > 0)) return null;
  const porcentaje = (Number(precio) - referencia) / referencia * 100;
  return Math.abs(porcentaje) < 0.005 ? 0 : porcentaje;
};
